const menuInfo = [
    // {
    //     label: 'Content',
    //     active: true,
    //     lists: [
    //         {
    //             "label":"Article 10min Feedback",
    //             "link":"/report/top_impression"
    //         },
    //         {
    //             "label":"Article Hourly Feedback",
    //             "link":"/report/index_article_hours"
    //         },
    //         {
    //             "label":"Push Article Accumulated Feedback",
    //             "link":"/report/index_daily_article_push"
    //         },
    //         {
    //             "label":"Article Accumulated Feedback(运营)",
    //             "link":"/report/index_realtime_article_daily"
    //         },
    //         {
    //             "label":"Article Daily Feedback",
    //             "link":"/report/t_daily_article"
    //         },
    //         {
    //             "label":"Article Daily Feedback(Operator)",
    //             "link":"/report/t_daily_article_operate"
    //         },
    //         {
    //             "label":"Mood Poll Daily Article",
    //             "link":"/report/index_ballot_article"
    //         }
    //     ]
    // },
    {
    	"label": "recommendation",
        "lists": [
            // {
            //     "label": "User 10min Feedback",
            //     "link": "/report/index_user_10min"
            // },
            // {
            //     "label": "User Hourly Feedback",
            //     "link": "/report/index_user_hours"
            // {
            //     "label": "top ctr(table)",
            //     "link": "/report/index_table_top_ctr"
            // },
            {
                "label": "top sale(table)",
                "link": "/report/index_table_top_sale"
            },
            // },
            // {
            //     "label": "User Daily Feedback",
            //     "link": "/report/index"
            // },
            // {
            //     "label": "User Daily Feedback(table)",
            //     "link": "/report/index_table"
            // },
            // {
            //     "label": "Multi-Dimensional User Retention Rate",
            //     "link": "/report/index_user_retain"
            // },
            // {
            //     "label": "Multi-Dimensional User Retention Rate(table)",
            //     "link": "/report/index_user_retain_table"
            // },
            // {
            //     "label": "User Histogram",
            //     "link": "/report/index_user_histogram"
            // },
            // {
            //     "label": "Mood Poll Daily User",
            //     "link": "/report/index_ballot_user"
            // },
            // {
            //     "label": "recommend conversion",
            //     "link": "/report/index_recommend_conversion"
            // },
            // {
            //     "label": "recommend conversion hour",
            //     "link": "/report/index_recommend_conversion_hour"
            // },
            {
                "label": "recommend conversion streaming",
                "link": "/report/index_recommend_conversion_streaming"
            },
            // {
            //     "label": "exploit and explore",
            //     "link": "/report/index_exploit_and_explore"
            // },
            // {
            //     "label": "category and style CTR",
            //     "link": "/report/index_category_style_ctr"
            // },
            {
                "label": "recommend conversion item",
                "link": "/report/index_recommend_conversion_item"
            },
            {
                "label": "marketing_aicrm_invitation",
                "link": "/report/index_marketing_aicrm_invitation"
            },
            {
                "label": "marketing_aicrm_invitation_streaming",
                "link": "/report/index_marketing_aicrm_invitation_streaming"
            },
            {
                "label": "exploit and explore decay",
                "link": "/report/index_exploit_and_explore_decay"
            },
            {
                "label": "refer_cns_top_ctr",
                "link": "/report/index_refer_cns_top_ctr"
            },
            {
                "label": "top_cns_sale",
                "link": "/report/index_top_cns_sale"
            },
            {
                "label": "item_to_item_ctr",
                "link": "/report/index_item_to_item_ctr"
            },
            {
                "label": "prior_cns_exploit_pool",
                "link": "/report/index_prior_cns_exploit_pool"
            }

        ]
    }
    // , {
    //     "label": "Advertisement",
    //     "lists": [
    //         {
    //             "label":"AD Daily Feedback Revenue(chart&table)",
    //             "link":"/report/index_ad_daily_feedback_revenue"
    //         },
    //         {
    //             "label":"AD Feedback Revenue(table)",
    //             "link":"/report/index_ad_daily_feedback_revenue_table"
    //         },
    //         {
    //             "label":"AD Feedback",
    //             "link":"/report/index_ad_daily_chart"
    //         },
    //         {
    //             "label":"AD Feedback(table)",
    //             "link":"/report/index_ad_daily"
    //         },
    //         {
    //             "label": "AD Report Monitor",
    //             "link": "/report/index_ad_report_monitor"
    //         },
    //         {
    //             "label": "AD Report Monitor(table)",
    //             "link": "/report/index_ad_report_table_monitor"
    //         },
    //         {
    //             "label":"AD News Indicator",
    //             "link":"/report/index_ad_news_indicator"
    //         }
    //     ]
    // },
    // {
    //     "label": "H5 Share",
    //     "lists": [
    //         {
    //             "label": "H5 Server Log Statistics",
    //             "link": "/report/index_daily_h5"
    //         },
    //         {
    //             "label": "Article 10min Share In APP",
    //             "link": "/report/index_daily_h5share"
    //         },
    //         {
    //             "label": "H5 share page behavior funnel",
    //             "link": "/report/index_daily_pageview_funnel"
    //         },
    //         {
    //             "label": "H5 share page User funnel",
    //             "link": "/report/index_daily_page_user"
    //         }
    //     ]
    // },
    // {
    //     "label": "Monitor",
    //     "lists": [
    //         {
    //             "label": "New User Funnel Monitor",
    //             "link": "/report/funnel_monitor_new_user"
    //         },
    //         {
    //             "label": "New User Funnel Monitor(table)",
    //             "link": "/report/funnel_new_user_table"
    //         },
    //         {
    //             "label": "Throughput Monitor",
    //             "link": "/report/index_throughput"
    //         },
    //         {
    //             "label": "Available Publish Monitor",
    //             "link": "/report/index_publish"
    //         },
    //         {
    //             "label": "Explore monitor",
    //             "link": "/report/index_explore"
    //         }
    //     ]
    // },
    // {
    //     "label": "Media",
    //     "lists": [
    //         {
    //             "label": "Media pv",
    //             "link": "/report/index_media_pv"
    //         }
    //     ]
    // },
    // {
    //     "label": "Historical Data",
    //     "lists": [
    //         {
    //             "label": "Historical Data Search",
    //             "link": "/report/index_historical_data"
    //         }
    //     ]
    // },
    // {
    //     "label": "GMP",
    //     "lists": [
    //         {
    //             "label": "GMP Monitor",
    //             "link": "/report/gmp_monitor"
    //         }
    //     ]
    // },
    // {
    //     "label": "Push",
    //     "lists": [
    //         {
    //             "label": "Push Server Monitor-new",
    //             "link": "/report/index_push_server_new_monitor"
    //         },
    //         {
    //             "label": "Push Monitor",
    //             "link": "/report/monitor_push"
    //         },
    //         {
    //             "label": "Push Click User Analysis",
    //             "link": "/report/index_click_push"
    //         }
    //     ]
    // }
]


export default menuInfo



// WEBPACK FOOTER //
// ./src/config/menu.js